import React from 'react';

function HeadphoneIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8259 8.66667C19.7313 8.66667 19.6368 8.66667 19.5423 8.66667V8.09524C19.5423 4.7619 16.801 2 13.4925 2H11.3184C8.00995 2 5.26866 4.7619 5.26866 8.09524V8.7619C5.17413 8.7619 5.17413 8.7619 5.0796 8.7619C3.94527 8.66667 3 9.61905 3 10.8571V14.381C3 15.5238 3.94527 16.4762 5.0796 16.4762H6.21393C6.78109 16.4762 7.1592 16.0952 7.1592 15.5238V10.8571V8.09524C7.1592 5.80952 9.04975 3.90476 11.3184 3.90476H13.4925C15.7612 3.90476 17.6517 5.80952 17.6517 8.09524V9.61905V15.4286V16.4762C17.6517 18.2857 16.2338 19.8095 14.5323 20C14.2488 19.2381 13.5871 18.6667 12.6418 18.6667C11.3184 18.6667 10.6567 20 10.5622 20.8571C10.4677 21.1429 10.5622 21.4286 10.7512 21.619C10.9403 21.8095 11.2239 22 11.5075 22H14.1542C17.1791 22 19.6368 19.5238 19.6368 16.4762V16.381H19.9204C21.0547 16.381 22 15.4286 22 14.2857V10.8571C21.9055 9.61905 20.9602 8.66667 19.8259 8.66667Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default HeadphoneIcon;
